import { Thumbnail } from 'components/table/utility/Thumbnail'
import { AssetImageGenerator } from 'features/assetViz'
import { useRolodexEntries } from 'features/rolodex'
import React from 'react'
import {
  GeckoAssetModel,
  GeckoComponent,
  GeckoComponentDataFrame,
  GeckoInspection,
  GeckoUnit,
  RolodexEntryType,
} from 'types'

export const InspectionHeatmap: React.FC<{
  inspection: GeckoInspection
  component: GeckoComponent
  assetModel: GeckoAssetModel | undefined
  componentDataFrame: GeckoComponentDataFrame | undefined
  unit: GeckoUnit
}> = ({ inspection, component, assetModel, componentDataFrame, unit }) => {
  const { componentDefaults } = useRolodexEntries({
    type: [RolodexEntryType.COMPONENT_DEFAULTS],
    tags: { component: inspection.tags.component },
  })

  const componentDefault = componentDefaults.at(0)
  const colorThreshold = componentDataFrame
    ? componentDefault?.data.color_scale_thresholds.get(
        componentDataFrame.data.params.view.id
      )
    : undefined

  return (
    <Thumbnail>
      <AssetImageGenerator
        assetVizID={inspection.id}
        unit={unit}
        assetModel={assetModel}
        component={component}
        colorThreshold={colorThreshold}
        componentDataFrame={componentDataFrame}
      />
    </Thumbnail>
  )
}
